import React from "react";
import { browserTimezone } from "@/lib/timezones";

export default function TimezoneSelect({ value, onChange }) {
  const detected = browserTimezone();
  const zones = [...new Set([
    "UTC", detected, value,
    ...(Intl.supportedValuesOf ? Intl.supportedValuesOf("timeZone") : []),
  ].filter(Boolean))].sort();
  return (
    <label className="block space-y-1.5">
      <span className="text-sm font-medium">Tournament timezone</span>
      <select value={value || ""} onChange={(event) => onChange(event.target.value)}
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        data-testid="tournament-timezone">
        {!value && <option value="" disabled>Select a timezone</option>}
        {zones.map((zone) => <option key={zone} value={zone}>{zone}</option>)}
      </select>
      <span className="block text-xs text-muted-foreground">Detected from your browser: {detected}. Game times use the saved tournament timezone.</span>
    </label>
  );
}
